import { render, staticRenderFns } from "./ConversionDuplicationToggle.vue?vue&type=template&id=45f8b344"
import script from "./ConversionDuplicationToggle.vue?vue&type=script&lang=js"
export * from "./ConversionDuplicationToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports